import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

/**
 * Firebase.
 *
 * ★ 설정값은 `generated_code/lib/backend/firebase/firebase_config.dart` 를 그대로
 *   옮긴 것이다. **웹 키는 공개값**이다 — Flutter 웹 빌드에도 그대로 들어 있다.
 *
 * ⚠️⚠️ **키가 공개라는 것이 곧 데이터가 열려 있다는 뜻은 아니다.** 실제 차단은
 * `firestore.rules` 다 — `users/{uid}.approved == true` 가 아니면 `events` 를
 * 한 건도 못 읽는다. ★ 가입 화면을 닫아 두는 것은 **보안이 아니라 편의**다
 * (Auth REST API 로 계정은 만들 수 있다).
 *
 * ⚠️ 배포 URL 을 **「승인된 도메인」에 등록**해야 로그인이 된다(콘솔 →
 * Authentication → 설정). 안 하면 버튼을 눌러도 **화면에 아무 표시 없이**
 * 아무 일도 일어나지 않는다. `web.app` 과 `firebaseapp.com` 은 별개다.
 */
export const firebaseApp = initializeApp({
  apiKey: 'AIzaSyD5ghY4h9OEbyMkyzElhPT5WDR0DX-9u60',
  authDomain: 'lens-k2s9j1.firebaseapp.com',
  projectId: 'lens-k2s9j1',
  storageBucket: 'lens-k2s9j1.firebasestorage.app',
  messagingSenderId: '152329641892',
  appId: '1:152329641892:web:ec207ca3598d2fd0edeb31',
});

export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
